import createRequestTypes from '../../services/requestsTypes';

const filePrefix = 'NEXODUS';
export const NEXODUS_CONNECT = createRequestTypes(`${filePrefix}_CONNECT`);
export const NEXODUS_WEBHOOK = createRequestTypes(`${filePrefix}_WEBHOOK`);
export const NEXODUS_IMPORT_INVOICE = createRequestTypes(`${filePrefix}_IMPORT_INVOICE`);

export const nexodusConnectRequest = (data: any) => ({
  type: NEXODUS_CONNECT.REQUEST,
  data,
});
export const nexodusConnectSuccess = (data: any) => ({
  type: NEXODUS_CONNECT.SUCCESS,
  data,
});
export const nexodusConnectFailure = (error: any) => ({
  type: NEXODUS_CONNECT.FAILURE,
  error,
});

export const nexodusImportInvoiceRequest = (invoiceNumber: string) => ({
  type: NEXODUS_IMPORT_INVOICE.REQUEST,
  data: { invoiceNumber },
});
export const nexodusImportInvoiceSuccess = () => ({
  type: NEXODUS_IMPORT_INVOICE.SUCCESS,
});
export const nexodusImportInvoiceFailure = (error: any) => ({
  type: NEXODUS_IMPORT_INVOICE.FAILURE,
  error,
});

export const nexudusWebhookRequest = (payload: { webhookUrl: string } | { ids: number[] }) => ({
  type: NEXODUS_WEBHOOK.REQUEST,
  data: payload,
});
export const nexudusWebhookSuccess = () => ({
  type: NEXODUS_WEBHOOK.SUCCESS,
});
export const nexudusWebhookFailure = (error: any) => ({
  type: NEXODUS_WEBHOOK.FAILURE,
  error,
});
